import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { captureResetToken } from './lib/resetToken';

// Före rendering och därmed före analysinitiering: ingen token kvar i adressen.
captureResetToken();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 